import React from 'react';
import ReactDOM from 'react-dom/client'; 
import Clarity from '@microsoft/clarity';
import App from './components/App';
import { HelmetProvider } from 'react-helmet-async';

Clarity.init('v5yf0i7af2');

const rootElement = document.getElementById("root");

const root = ReactDOM.createRoot(rootElement);  
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
